import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=31524483&"
import script from "./preloader.vue?vue&type=script&lang=js&"
export * from "./preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports